// You can refer to Feature Flag definition in
// env vars within this enum:
// NewUIFeatureExample = 'NEW_UI_FEATURE_EXAMPLE',
export enum Features {
  DISABLE_NNW_INDIVIDUAL_AGE_GROUP = 'DISABLE_NNW_INDIVIDUAL_AGE_GROUP',
  ENABLE_NNW_SCHOOL_TWO_YEAR = 'ENABLE_NNW_SCHOOL_TWO_YEAR',
  ENABLE_INLINE_CONSENTS = 'ENABLE_INLINE_CONSENTS',
}

export type FeatureFlags = Record<Features, boolean>;

export const FEATURE_FLAGS_KEY = 'featureFlags';
